import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tooltip, IconButton } from '@material-ui/core';
import { LinkOff as LinkOffIcon, RemoveRedEye as ViewIcon, People as PeopleIcon } from '@material-ui/icons';
import { FHETable, DetailPanelUsers } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { dissociateSDM18MVRUser, dissociateSDM18MVRUserAndSwitchMaster } from '../../../data/SDM18MVR/actions';

class TableSDM18MVR extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dissociateSDM18MVRUser: PropTypes.func.isRequired,
        dissociateSDM18MVRUserAndSwitchMaster: PropTypes.func.isRequired,
        SDM18MVRs: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dissociateLoading: null
        };
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/SDM18MVR/detail/${rowData.id}` });
    };

    navigateToUser = event => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/user/detail/${event.currentTarget.getAttribute('data-userid')}`
        });
    };

    /* ACTIONS */
    dissociateUser = SDM18MVRMac => {
        const { dissociateSDM18MVRUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18MVRMac });

        dissociateSDM18MVRUser(SDM18MVRMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18MVR.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18MVR.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMaster = SDM18MVRMac => {
        const { dissociateSDM18MVRUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18MVRMac });

        dissociateSDM18MVRUser(SDM18MVRMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18MVR.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18MVR.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMasterAndSwitch = (SDM18MVRMac, newMasterId) => {
        const { dissociateSDM18MVRUserAndSwitchMaster, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18MVRMac });

        dissociateSDM18MVRUserAndSwitchMaster(SDM18MVRMac, userId, newMasterId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18MVR.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18MVR.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateProduct = rowData => {
        const { dissociateLoading } = this.state;
        const { userId, history } = this.props;
        if (dissociateLoading === rowData.id) return false;
        if (rowData.otherUsers.length === 0 && rowData.userMasterId === userId) {
            Toastr.confirm(
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemoveMasterAlone`, rowData.macAddress),
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemoveMasterTitle`),
                {
                    onYes: () => {
                        this.dissociateMaster(rowData.id);
                    }
                }
            );
        } else if (rowData.userMasterId === userId) {
            Toastr.select(
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemoveMaster`, rowData.macAddress),
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemoveMasterTitle`),
                rowData.otherUsers,
                {
                    onYes: newMasterId => {
                        this.dissociateMasterAndSwitch(rowData.id, parseInt(newMasterId));
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemove`, rowData.macAddress),
                Translator.translate(`general.products.SDM18MVR.table.action.dissociate.confirmRemoveTitle`),
                {
                    onYes: () => {
                        this.dissociateUser(rowData.id);
                    }
                }
            );
        }
    };

    /* RENDER */
    renderData = memoizeOne(SDM18MVRs => {
        let result = [];

        SDM18MVRs.map(SDM18MVR => {
            result.push({
                id: SDM18MVR.get('macAddress'),
                macAddress: SDM18MVR.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM18MVR.get('addressIp'),
                email: SDM18MVR.get('userEmail'),
                label: SDM18MVR.get('label'),
                state: SDM18MVR.getIn(['state'], false) ? Translator.translate(`general.${SDM18MVR.get('state')}`) : null,
                firmwareVersion: SDM18MVR.get('firmwareVersion'),
                usersList: SDM18MVR.get('usersList'),
                otherUsers: SDM18MVR.get('otherUsers'),
                userMasterId: SDM18MVR.get('userMasterId')
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [
                {
                    icon: LinkOffIcon,
                    onClick: this.dissociateProduct,
                    tooltip: Translator.translate(`general.products.SDM18MVR.table.action.dissociate.tooltip`)
                }
            ],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('SDM18MVRDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderDetails = memoizeOne(() => {
        return {
            renderToggleCell: ({ row, onToggle }) => {
                return (
                    <Tooltip title={Translator.translate('general.table.button.showUserList')} disableHoverListener={!row.userMasterId}>
                        <span>
                            <IconButton onClick={onToggle} disabled={!row.userMasterId}>
                                <PeopleIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
            renderPanel: ({ row }) => {
                return <DetailPanelUsers usersList={row.usersList} userMasterId={row.userMasterId} onClick={this.navigateToUser} />;
            }
        };
    });

    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM18MVRDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });

    renderSDM18MVR() {
        const { SDM18MVRs, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailSDM18MVR"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM18MVRs)}
                actions={this.renderActions(profile)}
                rowDetail={this.renderDetails()}
                minified
            />
        );
    }

    render() {
        const { SDM18MVRs, history } = this.props;
        return (
            <Fragment>
                {SDM18MVRs.size > 0 ? this.renderSDM18MVR() : Translator.translate(`general.products.SDM18MVR.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const userId = props.match.params.userId;
    const users = state.environments[history.environment].data.Users.get('list');
    const actualUser = users.getIn([userId], new Map());
    let SDM18MVRs = state.environments[history.environment].data.SDM18MVR.get('list')
        .filter(SDM18MVR => {
            return SDM18MVR.getIn(['usersList'], []).indexOf(parseInt(userId)) !== -1;
        })
        .map(SDM18MVR => {
            const masterUser = users.getIn([SDM18MVR.getIn(['userMasterId'], '').toString()], new Map());
            let otherUsers = [];
            const usersList = SDM18MVR.getIn(['usersList'], [])
                .map(_userId => {
                    const _user = users.getIn([_userId.toString()], new Map());
                    if (parseInt(userId) !== _user.get('_id'))
                        otherUsers.push({ id: _user.get('_id'), label: `${_user.get('firstname')} ${_user.get('lastname')}` });
                    return _user;
                })
                .sort(a => {
                    if (a.get('_id') === SDM18MVR.get('userMasterId')) return -1;
                    else return 1;
                });
            return SDM18MVR.set('userEmail', masterUser.get('email'))
                .set('usersList', usersList)
                .set('otherUsers', otherUsers);
        });
    return {
        profile: state.data.user,
        user: actualUser,
        users,
        SDM18MVRs
    };
}

const styles = theme => ({
    detailPanelHeader: {
        color: theme.palette.text.secondary
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { dissociateSDM18MVRUser, dissociateSDM18MVRUserAndSwitchMaster }), dispatch)
    )(withStyles(styles, { withTheme: true })(TableSDM18MVR))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableSDM18MVR.js